export default "__VITE_ASSET__7XkgQ$S6__"